import {
  Avatar,
  Box,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";

function ProfileAndCommentComponent({
  replyLeftPadding = "0px",
  primaryText,
  secondaryText,
  bluetick = false,
  avatarSrc = "",
  menuOrImojiButton,
  children,
  postDescription = false,
  commentDescription = false,
  reply = false,
  profile = false,
  onlyReply = false,
  listButton = true,
  jobSectionProfileCustomization = false,
}) {
  return (
    <Stack sx={{ pl: replyLeftPadding }}>
      {reply && (
        <Box sx={{ width: "1px", height: "36px", bgcolor: "#CCCCCC" }}></Box>
      )}

      <List sx={{ py: "0px" }}>
        <ListItem sx={{ p: "0px" }}>
          <ListItemAvatar sx={{ alignSelf: "start" }}>
            {avatarSrc !== "" && (
              <Avatar
                src={avatarSrc}
                sx={{
                  width: reply ? 40 : 50,
                  height: reply ? 40 : 50,
                  objectFit: "cover",
                  bgcolor: "#EBEBEB",
                }}
              />
            )}
          </ListItemAvatar>
          <ListItemText
            primary={
              <Box display="flex" alignItems="center" sx={{ p: "0px" }}>
                <Typography variant="Subtitle1" sx={{ fontSize: reply ? "17px" : "18.5px" }}>
                  {primaryText}
                </Typography>
                {bluetick && (
                  <Box component="img" src="/icons/bluetick.svg" sx={{ pl: "2px" }} />
                )}
              </Box>
            }
            secondary={secondaryText}
            sx={{
              width: reply ? "70%" : "100%",
              "& .MuiTypography-root": { pl: "4px" },
              "& .MuiTypography-body1": {
                color: "#000000",
                fontWeight: "bold",
                lineHeight: "22px",
                pl: "0px",
                pt: "0px",
              },
              "& .MuiTypography-body2": {
                color: "#000000",
                fontWeight: "500",
              },
            }}
          />
          <Typography variant="body2" sx={{ color: "#000000", fontWeight: "400", mt: 1 }}></Typography>
          {reply ? (
            <Typography
              sx={{
                alignSelf: "start",
                justifySelf: "end",
                color: "#9C9C9C",
                fontSize: "12px",
              }}
              variant="body2"
            >
              {menuOrImojiButton.text}
            </Typography>
          ) : (
            <Button
              variant="text"
              sx={{
                padding: "0px",
                minWidth: "auto",
                width: "auto",
                textTransform: "none",
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "start",
                "&:hover": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                },
                "&:active": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                },
                "&:focus": {
                  outline: "none",
                },
                "& .MuiButtonBase-root": {
                  width: "auto !important",
                  minWidth: "0px !important",
                  padding: "0px",
                },
                color: "#000000",
              }}
              startIcon={
                listButton && (
                  <Box
                    component="img"
                    src={menuOrImojiButton?.src}
                    sx={{ width: 16, height: 16 }}
                  />
                )
              }
            >
              {menuOrImojiButton?.text}
            </Button>
          )}
        </ListItem>
      </List>
      {postDescription && <Box sx={{ pt: "12px" }}>{children} </Box>}
      <Box sx={{ pl: "60px" }}>
        {commentDescription && children}
        {!profile && (
          <Box
            sx={{
              color: "#9C9C9C",
              display: "flex",
              gap: "10px",
              alignItems: "center",
              pt: reply ? "0px" : "7px",
              pl: reply ? "30px" : "0px",
            }}
          >
            {reply && (
              <>
                <Button
                  variant="text"
                  sx={{
                    width: "auto",
                    minWidth: "0",
                    color: "#9C9C9C",
                    "&:hover": {
                      backgroundColor: "transparent",
                      boxShadow: "none",
                    },
                    "&:active": {
                      backgroundColor: "transparent",
                      boxShadow: "none",
                    },
                    "&:focus": {
                      outline: "none",
                    },
                    textTransform: "none",
                    p: "0px",
                  }}
                >
                  Like
                </Button>
                <Box
                  sx={{
                    width: "6px",
                    height: "6px",
                    bgcolor: "#9c9c9c",
                    borderRadius: "50%",
                  }}
                ></Box>
              </>
            )}
            {onlyReply ? (
              <Button
                variant="text"
                sx={{
                  width: "auto",
                  minWidth: "0",
                  color: "#9C9C9C",
                  "&:hover": {
                    backgroundColor: "transparent",
                    boxShadow: "none",
                  },
                  "&:active": {
                    backgroundColor: "transparent",
                    boxShadow: "none",
                  },
                  "&:focus": {
                    outline: "none",
                  },
                  textTransform: "none",
                  p: "0px",
                }}
              >
                Reply
              </Button>
            ) : (
              <>
                <Button
                  variant="text"
                  sx={{
                    width: "auto",
                    minWidth: "0",
                    color: "#9C9C9C",
                    "&:hover": {
                      backgroundColor: "transparent",
                      boxShadow: "none",
                    },
                    "&:active": {
                      backgroundColor: "transparent",
                      boxShadow: "none",
                    },
                    "&:focus": {
                      outline: "none",
                    },
                    textTransform: "none",
                    p: "0px",
                  }}
                >
                  Reply
                </Button>
                <Box
                  sx={{
                    width: "6px",
                    height: "6px",
                    bgcolor: "#9c9c9c",
                    borderRadius: "50%",
                  }}
                ></Box>
                <Button
                  variant="text"
                  sx={{
                    width: "auto",
                    minWidth: "0",
                    color: "#9C9C9C",
                    "&:hover": {
                      backgroundColor: "transparent",
                      boxShadow: "none",
                    },
                    "&:active": {
                      backgroundColor: "transparent",
                      boxShadow: "none",
                    },
                    "&:focus": {
                      outline: "none",
                    },
                    textTransform: "none",
                    p: "0px",
                  }}
                >
                  View 2 replies
                </Button>
              </>
            )}
          </Box>
        )}
      </Box>
    </Stack>
  );
}

export default ProfileAndCommentComponent;
